<div fxLayout="row" class="breadcrumb p-2 " @listTransition>
	<div *ngFor="let breadcrumb of breadcrumbs; let i = index;" [class.listTransition]="i > 0" class="breadcrumb-item" fxLayout="row" fxLayoutAlign="start center">
		<mat-icon *ngIf="i == 0">home</mat-icon>
		<a [hidden]="i == (breadcrumbs.length - 1)" [routerLink]="[breadcrumb.url]" (click)="closeSubMenus(i)">{{breadcrumb.name}}</a>
		<span [hidden]="i != (breadcrumbs.length - 1)" class="breadcrumb-title active">{{breadcrumb.name}}</span>
	</div>
</div>